import { IClientPassengerBrief } from '@bustickus/models-client';
import { Box, Flex, Header } from 'components';
import { PassengerDocument } from '..';
import './style.scss';

interface IProps {
  passenger: IClientPassengerBrief;
}

function PassengerDocuments(props: IProps) {
  return (
    <Box
      padding={10}
      shadow='inside'
      className='passenger-doc-list-Aukg'
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Header>Необходимые документы</Header>
        {props.passenger.passport != null && (
          <PassengerDocument
            title='Паспорт Российской Федерации'
            status={props.passenger.passport}
          />
        )}

        {props.passenger.foreignPassport != null && (
          <PassengerDocument
            title='Заграничный паспорт'
            status={props.passenger.foreignPassport}
          />
        )}

        {props.passenger.visas.map((x) => (
          <PassengerDocument
            key={x.visaId}
            title={`Виза (${x.visaName})`}
            status={x.status}
          />
        ))}
      </Flex>
    </Box>
  );
}

export default PassengerDocuments;
